import { render, staticRenderFns } from "./TK012MemberTdkDetails.vue?vue&type=template&id=12506d5f&"
import script from "./TK012MemberTdkDetails.vue?vue&type=script&lang=js&"
export * from "./TK012MemberTdkDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports